import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'

export default [
  // ===
  // 購買包套方案
  // ===
  {
    path: '/prepaid',
    name: 'prepaid',
    component: () => process.env.VUE_APP_MODE === 'dingbeauty' ? lazyLoadView(import('@views/Prepaid-db/Index')) : lazyLoadView(import('@views/Prepaid/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (!store.state.merchant.currentMerchant?.prepaidSetting?.isEnabled)
          next({ name: '404' })
          if(process.env.VUE_APP_MODE === 'jtails') {
            const storeType = routeTo.query.storeType;

            if(!storeType) {
              return next({
                name: 'prepaid',
                query: {
                  storeType: 'store'
                }
              })
            }

            const isValidStoreTypeList = () => {
              const validStoreTypeList = [
                'store',
                'home'
              ];

              return !storeType || validStoreTypeList.includes(storeType);
            };

            if(!isValidStoreTypeList()) {
              return next({
                name: '404'
              })
            }

            const [
              currentPrepaidList
            ] = await Promise.all([
              store.dispatch('merchant/fetchPrepaidList', {
                useCached: true
              }),
            ]);
            routeTo.params.prepaidItemMap = currentPrepaidList.items;
          } else {
            routeTo.params.prepaidItemMap = {}
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      prepaidItemMap: route.params.prepaidItemMap || []
    }),
  },
  // ===
  // 購買包套方案 內容頁
  // ===
  {
    path: '/prepaid/:prepaidAlias',
    name: 'prepaid-item',
    component: () => lazyLoadView(import('@views/Prepaid/Item.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentPrepaidItem
          ] = await Promise.all([
            store.dispatch('merchant/fetchPrepaidItem', {
              prepaidAlias: routeTo.params.prepaidAlias,
            }),
          ]);

          routeTo.params.prepaidItem = currentPrepaidItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
    props: (route) => ({
      prepaidItem: route.params.prepaidItem || {}
    }),
  },
  // ===
  // 使用包套方案
  // ===
  {
    path: '/prepaid-reservation',
    name: 'prepaid-reservation',
    component: () => lazyLoadView(import('@views/Prepaid/Reservation.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['merchant/isSiteEnabled'])
          next({ name: '404' })
        try {
          if(store.getters['auth/isLoggedIn']) {
            await store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            });
          }

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
  },
]
